import ordinal from 'ordinal';

angular.module('filters').filter('ordinalize', function() {
  return function(data) {
    return ordinal(data);
  };
});
